import { Injectable } from '@angular/core';
import { FullActivity, FullCategory } from '../../category/category.query';

@Injectable()
export class ForecastTableGridTotalService {
  parseCategoryTotal(category: FullCategory | FullActivity): number {
    return category.BUDGET_PRIMARY?.total_cost || 0;
  }
}
